import country from './data.json';
import phone from './phone.json';

export const countryList = country;
export const phoneList = phone;
